"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var styled_1 = require("./styled");

var Positions;

(function (Positions) {
  Positions["Top"] = "top";
  Positions["Bottom"] = "bottom";
  Positions["Left"] = "left";
  Positions["Right"] = "right";
})(Positions = exports.Positions || (exports.Positions = {}));
/**
 * Label - for labeling form fields
 */


var Label = function Label(props) {
  var text = props.text,
      children = props.children,
      _props$position = props.position,
      position = _props$position === void 0 ? Positions.Left : _props$position,
      _props$error = props.error,
      error = _props$error === void 0 ? "" : _props$error;
  var content = position === Positions.Right || position === Positions.Bottom ? react_1["default"].createElement(react_1["default"].Fragment, null, error && react_1["default"].createElement(styled_1.Error, null, error), children, text) : react_1["default"].createElement(react_1["default"].Fragment, null, text, children, error && react_1["default"].createElement(styled_1.Error, null, error));
  return react_1["default"].createElement(styled_1.LabelStyle, Object.assign({
    position: position
  }, props), content);
};

Label.Positions = Positions;
exports["default"] = Label;